// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customStatusBadge .ant-badge sup {
  height: 28px;
  min-width: 75px;
  border-radius: 6px;
  padding: 4px;
  line-height: 1;
  display: flex !important;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
}
.statusPending sup,
.statusPanding sup {
  background-color: #fff0da !important;
  color: #ee9c22 !important;
}
.refunded sup {
  background-color: #cddaf5 !important;
  color: #5d81cb !important;
}
.statusCompleted sup,
.statusActive sup,
.statusApproved sup,
.statusPaid sup,
.category sup {
  background-color: #cdf5d3 !important;
  color: #39a84a !important;
}
.statusShipped sup,
.statusInvited sup {
  background-color: #2196f3 !important;
  color: #ffffff !important;
}
.statusFailed sup,
.statusReject sup {
  background-color: #e64a19 !important;
  color: #ffffff !important;
}
.statusInactive sup,
.statusDraft sup,
.statusCancelled sup {
  background-color: #edf2f7 !important;
  color: #8f8f8f !important;
}
.returnRequested sup {
  background-color: #b9e2ff !important;
  color: #237ebe !important;
}
.ant-table-filter-dropdown button:nth-child(2) {
  background: #c11b2f;
}
.ant-table-filter-dropdown button:nth-child(2):hover {
  background: #c11b2f !important;
}
@media (min-width: 481px) and (max-width: 767px) {
  .customStatusBadge {
    padding: 10px;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .customStatusBadge {
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UiComponents/CustomStatusBadge/CustomStatusBadge.less"],"names":[],"mappings":"AAEA;EAGM,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kCAAA;EACA,gBAAA;AAHN;AAQA;;EAGI,oCAAA;EACA,yBAAA;AAPJ;AAUA;EAEI,oCAAA;EACA,yBAAA;AATJ;AAaA;;;;;EAMI,oCAAA;EACA,yBAAA;AAZJ;AAgBA;;EAGI,oCAAA;EACA,yBAAA;AAfJ;AAmBA;;EAGI,oCAAA;EACA,yBAAA;AAlBJ;AAqBA;;;EAII,oCAAA;EACA,yBAAA;AApBJ;AAwBA;EAEI,oCAAA;EACA,yBAAA;AAvBJ;AA6BI;EACE,mBAAA;AA3BN;AA4BM;EACE,8BAAA;AA1BR;AA4DA;EACE;IACE,aAAA;EA1DF;AACF;AA6DA;EACE;IACE,aAAA;EA3DF;AACF","sourcesContent":["@import url(\"../../../assets/Styles/variables.less\");\n\n.customStatusBadge {\n  .ant-badge {\n    sup {\n      height: 28px;\n      min-width: 75px;\n      border-radius: 6px;\n      padding: 4px;\n      line-height: 1;\n      display: flex !important;\n      align-items: center;\n      justify-content: center;\n      text-transform: uppercase;\n      font-family: \"Poppins\", sans-serif;\n      font-weight: 600;\n    }\n  }\n}\n\n.statusPending,\n.statusPanding {\n  sup {\n    background-color: #fff0da !important;\n    color: #ee9c22 !important;\n  }\n}\n.refunded {\n  sup {\n    background-color: #cddaf5 !important;\n    color: #5d81cb !important;\n  }\n}\n\n.statusCompleted,\n.statusActive,\n.statusApproved,\n.statusPaid,\n.category {\n  sup {\n    background-color: #cdf5d3 !important;\n    color: #39a84a !important;\n  }\n}\n\n.statusShipped,\n.statusInvited {\n  sup {\n    background-color: #2196f3 !important;\n    color: #ffffff !important;\n  }\n}\n\n.statusFailed,\n.statusReject {\n  sup {\n    background-color: #e64a19 !important;\n    color: #ffffff !important;\n  }\n}\n.statusInactive,\n.statusDraft,\n.statusCancelled {\n  sup {\n    background-color: #edf2f7 !important;\n    color: #8f8f8f !important;\n  }\n}\n\n.returnRequested {\n  sup {\n    background-color: #b9e2ff !important;\n    color: #237ebe !important;\n  }\n}\n\n.ant-table-filter-dropdown {\n  button {\n    &:nth-child(2) {\n      background: @primary-color;\n      &:hover {\n        background: @primary-color !important;\n      }\n    }\n  }\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n@media (min-width: 481px) and (max-width: 767px) {\n  .customStatusBadge {\n    padding: 10px;\n  }\n}\n\n@media (min-width: 280px) and (max-width: 480px) {\n  .customStatusBadge {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
